/**
 * Реестр фиче-флагов приложения.
 *
 * Флаг разрешается в три шага (см. `resolveFeatureFlag`):
 *   1. override из localStorage (`imgame:ff:*`) — его ставит `?flow=` или вкладка «Эксперименты»;
 *   2. дата регистрации пользователя (`user.created_at`) не раньше `since`;
 *   3. иначе флаг выключен.
 */

import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n/i18n';

export type FeatureFlagName = 'applicationsFlowV2' | 'applicationsFlow1447';

export interface FeatureFlagDefinition {
  /** Ключ в localStorage, по соглашению `imgame:ff:<имя флага>`. */
  storageKey: string;
  /** Подпись для dev-вкладки «Эксперименты». */
  title: MessageDescriptor;
  /** Пояснение, что именно меняет флаг. */
  description: MessageDescriptor;
  /**
   * Дата отсечки: флаг включён у пользователей, зарегистрированных не раньше неё.
   * ISO-строка; сдвиг отсечки — правка одной константы, видимая в истории.
   */
  since: string;
}

/**
 * Дата старта эксперимента со вторым флоу вкладки «Заявки».
 */
export const APPLICATIONS_V2_SINCE = '2026-09-01T00:00:00Z';

/**
 * Не настоящая дата роллаута: `applicationsFlow1447` — A/B-тоггл ветки IMGM-1447 против
 * продакшена, а не эксперимент с постепенным включением по дате регистрации. Дата в далёком
 * будущем гарантирует «по умолчанию выключено» из общей `resolveFeatureFlag`, не дублируя её
 * логику отдельным механизмом — включается только вручную, на вкладке «Эксперименты».
 */
export const APPLICATIONS_FLOW_1447_SINCE = '2099-01-01T00:00:00Z';

export const FEATURE_FLAGS: Record<FeatureFlagName, FeatureFlagDefinition> = {
  applicationsFlowV2: {
    storageKey: 'imgame:ff:applicationsFlowV2',
    title: msg`Заявки: новый флоу`,
    description: msg`Второй вариант экранов вкладки «Заявки» соревнования — список команд и состав команды.`,
    since: APPLICATIONS_V2_SINCE,
  },
  applicationsFlow1447: {
    storageKey: 'imgame:ff:applicationsFlow1447',
    title: msg`Новый флоу 2.0 для заявок`,
    description: msg`Ветка IMGM-1447: модалка состава команды вместо отдельной страницы, обновлённые карточки и фильтры.`,
    since: APPLICATIONS_FLOW_1447_SINCE,
  },
};

export const FEATURE_FLAG_NAMES = Object.keys(FEATURE_FLAGS) as FeatureFlagName[];
